import React from 'react';
import AugmentHelpDescription from './AugmentHelpDescription';

/** About page: short tagline + long description from the same help copy as tooltips. */
function AboutAugmentDesc({ tagline, text }) {
  return (
    <AugmentHelpDescription
      tagline={tagline}
      desc={text}
      className="about-augment-desc-block"
      taglineClassName="about-augment-tagline"
      paragraphClassName="about-augment-desc"
    />
  );
}

export default AboutAugmentDesc;
